import styled from 'styled-components';

export const Dropdown = styled.div`
  min-width: ${props => props.minWidth};
  padding: 8px 0;
  background: #fff;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, .15);
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
`;

export const Item = styled.div`
  color: ${props => props.color || '#2f3539'};
  font-size: ${props => props.size || 'inherit'};
  white-space: nowrap;
  padding: 3px 20px;
  cursor: pointer;

  &:hover {
    color: ${props => props.color || '#262626'};
    background-color: #f5f5f5;
  }
`;

export const Divider = styled.div`
  width: calc(100% - 16px);
  height: 1px;
  margin: 3px 8px;
  background-color: #ededed;
`;
